// Falling-item physics. Quadratic y(t).
// Doc: docs/gameplay-config.md#falling-items-physics.

export type FallingItem = {
  id: number;
  kind: "ingredient" | "hazard";
  spriteIndex: number;
  x: number; // scene units
  spawnTime: number; // seconds since game start
  rotation: number; // radians, fixed at spawn for visual variety
};

/** y(t) of a falling item in scene units. Item spawns at y = -visualSize
 *  (just off the top edge) and accelerates downward at `gravity`. */
export function itemY(item: FallingItem, now: number, gravity: number, visualSize: number): number {
  const t = now - item.spawnTime;
  return -visualSize + 0.5 * gravity * t * t;
}
